import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerIntl, MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';


@NgModule({
	imports: [
		MatProgressSpinnerModule,
		MatSidenavModule,
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		MatOptionModule,
		MatInputModule,
		MatSelectModule,
		MatTabsModule,
		MatToolbarModule,
		MatRadioModule,
		MatExpansionModule,
		MatTooltipModule,
		MatCardModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatSnackBarModule,
		MatProgressBarModule,
		MatCheckboxModule,
		MatListModule,
		MatMenuModule,
		MatButtonToggleModule,
		MatGridListModule,
		MatDialogModule,
		MatAutocompleteModule,
		MatExpansionModule,
		MatCheckboxModule,
		MatListModule,
	],
	providers: [
		MatDatepickerIntl,
	],
	exports: [
		MatProgressSpinnerModule,
		MatSidenavModule,
		MatButtonModule,
		MatIconModule,
		MatFormFieldModule,
		MatOptionModule,
		MatInputModule,
		MatStepperModule,
		MatSelectModule,
		MatTabsModule,
		MatToolbarModule,
		MatRadioModule,
		MatExpansionModule,
		MatTooltipModule,
		MatCardModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatSnackBarModule,
		MatProgressBarModule,
		MatCheckboxModule,
		MatListModule,
		MatMenuModule,
		MatButtonToggleModule,
		MatGridListModule,
		MatDialogModule,
		MatAutocompleteModule,
		MatExpansionModule,
		MatCheckboxModule,
		MatListModule,
	],
})
export class MaterialModule {}
